import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import AdCard from '../components/AdCard';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../config/api';
import BackToHome from '../components/BackToHome';

const Favourites = () => {
  const { currentUser } = useAuth();
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFavourites = async () => {
      if (!currentUser) {
        setError('Please log in to view your favourites');
        setLoading(false);
        return;
      }

      try {
        const token = await currentUser.getIdToken();
        const response = await axios.get(API_ENDPOINTS.ADS.FAVOURITES, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        setAds(response.data);
        setError(null);
      } catch (error) {
        console.error('Error fetching favourite ads:', error);
        const errorMessage = error.response?.data?.error || 'Failed to fetch favourite ads';
        setError(errorMessage);
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchFavourites();
  }, [currentUser]);

  if (!currentUser) {
    return (
      <Container>
        <BackToHome />
        <Alert variant="warning" className="my-4">
          Please log in to view your favourites
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container>
        <BackToHome />
        <div className="text-center my-5">
          <p>Loading your favourite ads...</p>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <BackToHome />
        <Alert variant="danger" className="my-4">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container>
      <BackToHome />
      <h2 className="my-4">My Favourite Ads</h2>
      {ads.length === 0 ? (
        <p>You have no favourite ads yet.</p>
      ) : (
        <Row>
          {ads.map(ad => (
            <Col key={ad._id} md={4} className="mb-4">
              <AdCard ad={ad} />
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Favourites; 